export default __webpack_public_path__ + "src/images/packages/witklipfontein-eco-lodge/de53168d442e7f9b648097c029a703b3-1.jpg";